<template>
    <div class="error-page">
        <h1>Access denied</h1>
        <p>You don't have permission to view this page.</p>
        <div class="error-page-actions">
            <router-link :to="homeLink.to">
                <Bttn>{{ homeLink.label }}</Bttn>
            </router-link>
            <Bttn class="outlined" @click="$router.back()">Go back</Bttn>
        </div>
    </div>
</template>

<script>
import { useUserStore } from "js/stores/userStore";

export default {
    name: "Forbidden",
    computed: {
        homeLink() {
            return useUserStore().isLoggedIn
                ? { to: "/", label: "Go home" }
                : { to: "/login", label: "Log in" };
        },
    },
};
</script>
